<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">{{ $t('profit.title') }}</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <v-layout
        row
        wrap
        style="margin-bottom: 20px"
      >
        <!-- <v-flex
          class="px-3 pb-2"
          xs12
          sm6
          md4
          lg5
        >
          <v-select
            :items="branchesList"
            v-model="branches"
            multiple
            autocomplete
            hide-details
            chips
            deletable-chips
            label="Branch"
            clearable
          >
          </v-select>
        </v-flex> -->
        <v-flex
          class="px-3 pb-2 mt-2"
          xs12
          sm6
          md4
          lg2
        >
          <date-picker
            style="border-bottom-color: #919191; width: 100%;"
            :date="startTime"
            :option="option"
            class="form-control"
          ></date-picker>
        </v-flex>

        <v-flex
          class="px-3 pb-2 mt-2"
          xs12
          sm6
          md4
          lg2
        >
          <date-picker
            style="border-bottom-color: #919191"
            :date="startTime1"
            :option="option1"
            class="form-control"
          ></date-picker>
        </v-flex>

        <v-flex
          xs2
          sm2
          md2
          lg1
          xl1
          class="mt-3"
        >
          <v-btn
            outline
            depressed
            class="pt-0"
            small
            @click="resetFilter()"
          >
            {{ $t('common.reset') }}
          </v-btn>
        </v-flex>

        <v-flex
          xs2
          sm2
          md2
          lg1
          xl1
          class="mt-3"
        >
          <v-btn
            outline
            depressed
            class="pt-0"
            small
            color="primary"
            @click="applyFilter()"
          >
            {{ $t('statistics.applyButton') }}
          </v-btn>
        </v-flex>
      </v-layout>

      <v-layout
        row
        wrap
      >
        <v-flex
          class="pb-4 px-3 text-center"
          xs12
          sm6
        >
          <v-card class="blue lighten-3">
            <v-card-text>
              <h4 class="mt-0">{{ $t('profit.totalInternationalShipment') }}</h4>
              <h3 class="mt-0">{{ apiData.total_shipment | usdFormat }}</h3>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex
          class="pb-4 px-3 text-center"
          xs12
          sm6
        >
          <v-card class="blue lighten-3">
            <v-card-text>
              <h4 class="mt-0">{{ $t('profit.totalShippingInvoiceShipment') }}</h4>
              <h3 class="mt-0">{{ apiData.total_invoice_shipment | usdFormat }}</h3>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex
          class="pb-4 px-3 text-center"
          xs12
          sm6
        >
          <v-card class="blue lighten-3">
            <v-card-text>
              <h4 class="mt-0">{{ $t('profit.totalLocalTax') }}</h4>
              <h3 class="mt-0">{{ apiData.total_tax | usdFormat }}</h3>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex
          class="pb-4 px-3 text-center"
          xs12
          sm6
        >
          <v-card class="blue lighten-3">
            <v-card-text>
              <h4 class="mt-0">{{ $t('profit.totalFee') }}</h4>
              <h3 class="mt-0">{{ apiData.total_fee | usdFormat }}</h3>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex
          class="pb-4 px-3 text-center"
          xs12
          sm6
        >
          <v-card class="red lighten-3">
            <v-card-text>
              <h4 class="mt-0">{{ $t('profit.totalRefund') }}</h4>
              <h3 class="mt-0">{{ apiData.total_refund | usdFormat }}</h3>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex
          class="pb-4 px-3 text-center"
          xs12
          sm6
        >
          <v-card class="green lighten-3">
            <v-card-text>
              <h4 class="mt-0">{{ $t('profit.totalIncome') }}</h4>
              <h3 class="mt-0">{{ apiData.income | usdFormat }}</h3>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex
          class="pb-4 px-3 text-center"
          xs12
          sm6
        >
          <v-card class="red lighten-3">
            <v-card-text>
              <h4 class="mt-0">{{ $t('profit.totalExpense') }}</h4>
              <h3 class="mt-0">{{ apiData.expense | usdFormat }}</h3>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex
          class="pb-4 px-3 text-center"
          xs12
          sm6
        >
          <v-card class="grey darken-3 white--text">
            <v-card-text>
              <h4 class="mt-0">{{ $t('profit.title') }}</h4>
              <h3 class="mt-0">{{ apiData.profit | usdFormat }}</h3>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import myDatepicker from 'vue-datepicker'

export default {
  components: {
    'date-picker': myDatepicker
  },

  data() {
    return {
      branchesList: [],
      branches: [],
      apiData: {},
      queryParams: {
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      startTime: {
        time: ''
      },
      startTime1: {
        time: ''
      },
      option: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],
        format: 'YYYY-MM-DD',
        placeholder: this.$t('columns.fromDate'),
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      option1: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],
        format: 'YYYY-MM-DD',
        placeholder: this.$t('columns.toDate'),
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true// as true as default
      }
    }
  },

  mounted() {
    this.getConnectedBranches()
    this.getData()
  },

  methods: {
    getConnectedBranches() {
      this.branchesList = []
      let token = localStorage.getItem('access_token')
      Axios
        .get('api/branch/connected-branch-list', { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let result = response.data
          result.forEach(r => {
            this.branchesList.push({ text: r.branch_name, value: r.branch_id })
          })
        })
    },

    getData() {
      var token = localStorage.getItem('access_token')
      Axios.get('api/profit', { params: this.queryParams, headers: { Authorization: 'Bearer ' + token } }).then((res) => {
        this.apiData = res.data
      })
    },

    resetFilter() {
      this.startTime.time = ''
      this.startTime1.time = ''

      this.queryParams.from_date = ''
      this.queryParams.to_date = ''

      this.getData()
    },

    applyFilter() {
      this.queryParams.from_date = this.startTime.time
      this.queryParams.to_date = this.startTime1.time
      this.queryParams.branches_id = this.branches.toString()

      this.getData()
    }
  }
}
</script>

<style scoped>

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/profit.vue